import { motion } from "framer-motion";
import { IMG } from "@/data/content";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Img = ({ src, alt, className = "", ...rest }) => (
  <img
    src={src}
    alt={alt}
    loading="lazy"
    onError={(e) => {
      if (e.currentTarget.src !== IMG.fallback) e.currentTarget.src = IMG.fallback;
    }}
    className={className}
    {...rest}
  />
);
